import {
  CreatePromocodePayload,
  IPromocodeApiCall,
  IRestApiService,
  Promocode,
  PromocodeAnalytics,
  PromocodeApplication,
} from '../types';

class PromocodeApiCall implements IPromocodeApiCall {
  constructor(private restApiService: IRestApiService) {}

  create(ownerId: string, payload: CreatePromocodePayload): Promise<Promocode> {
    return this.restApiService.post(`promocodes/${ownerId}`, payload);
  }

  list(ownerId: string): Promise<Promocode[]> {
    return this.restApiService.get<{ items: Promocode[] }>(`promocodes/${ownerId}`).then(({ items }) => items);
  }

  analytics(ownerId: string, dateFrom: string, dateTo: string, promocodeId?: string): Promise<PromocodeAnalytics> {
    const query = new URLSearchParams({ dateFrom, dateTo });
    if (promocodeId) query.set('promocodeId', promocodeId);
    return this.restApiService.get(`promocodes/${ownerId}/analytics?${query.toString()}`);
  }

  apply(ownerId: string, studioClientId: string, code: string): Promise<PromocodeApplication> {
    return this.restApiService.post(`promocodes/${ownerId}/client/${studioClientId}/apply`, { code });
  }

  active(ownerId: string, studioClientId: string): Promise<{ application: PromocodeApplication | null }> {
    return this.restApiService.get(`promocodes/${ownerId}/client/${studioClientId}/active`);
  }
}

export default PromocodeApiCall;
